/**
 * This file was auto-generated by Fern from our API Definition.
 */

export type CommentObjectType = "TRACE" | "OBSERVATION" | "SESSION" | "PROMPT";
export const CommentObjectType = {
  Trace: "TRACE",
  Observation: "OBSERVATION",
  Session: "SESSION",
  Prompt: "PROMPT",
} as const;
